import React from "react";
import Test from "./test";

const info = {
  difficulty: "medium",
  title: "Three Sum",
  url: "three-sum",
  problem: React.lazy(() => import(`./problem`)),
  test: Test,
  starter: `/**
* @param {number[]} nums
* @param {number} target
* @return {boolean}
*/
    
/**
* Do not change this function body
* Do your changes within the function 
*/

return function threeSum(nums, target) {
  // your code goes here        
};
`,
};

export default info;
